import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import applyMappingsToClone from '../../../assets/scripts/utilities/apply-mappings-to-clone.js'

export default class FeaturedEpisodeComponent extends Component {
  init() {
    this.container = this.element.querySelector('.featured-episode__wrapper')
    this.template = this.element.querySelector('.featured-episode__template')

    if (!this.container || !this.template) {
      return
    }

    window.addEventListener('fetch-data', event => this.onFetchData(event))
    this.element.reinitAfterFetch = () => this.onFetchData({ detail: this.data })
  }

  onFetchData(event) {
    if (!event.detail) {
      return
    }

    this.data = { ...event.detail }

    const orderMap = new Map((this.data.character_order || []).map((id, index) => [id, index]))

    this.characters = this.data.characters?.length ? [...this.data.characters] : []
    this.characters.sort((a, b) => (orderMap.get(a.id) ?? Infinity) - (orderMap.get(b.id) ?? Infinity)) // Sort characters based on order

    this.episodes = this.data.episodes?.length ? [...this.data.episodes].sort((a, b) => a.id - b.id) : []
    this.episodes = this.episodes.filter(episode => episode.is_released)

    this.highlights = this.data.highlights?.length ? [...this.data.highlights] : []
    this.highlights = this.highlights.filter(highlight => this.episodes.find(episode => episode.id === highlight.episode))
    this.highlights = this.highlights.map(highlight => {
      const episode = this.data.episodes.find(episode => episode.id === highlight.episode)

      return episode ? { ...episode, title: highlight.title || episode.title, image: highlight.image || episode.image } : null
    })

    this.render()
  }

  render() {
    this.container.setAttribute('hidden', 'hidden')

    if (this.container.children.length) {
      ;[...this.container.children].forEach(child => child.remove())
    }

    if (!this.highlights.length) {
      return
    }

    const episode = this.highlights.reduce((a, b) => (a.release_offset < b.release_offset ? a : b))

    if (!episode) {
      return
    }

    const character = this.characters.find(character => character.episodes?.indexOf(episode.id) !== -1)

    if (!character) {
      return
    }

    const clone = this.template.content.cloneNode(true)

    const mappings = [
      { selector: '.episode-highlight', values: { id: `episode-highlight-${episode.id}`, href: `${character.url}#episode-card-${episode.id}` } },
      { selector: '.episode-highlight__image', values: { src: episode.image, alt: episode.title } },
      { selector: '.episode-highlight__title', values: { textContent: episode.title } },
      { selector: '.episode-highlight__pretitle', values: { textContent: `${character.title}, ${episode.display_date.toString().toLowerCase()}` } },
      { selector: '.episode-highlight__description', values: { textContent: episode.description } },
    ]

    applyMappingsToClone(mappings, clone)

    this.container.appendChild(clone)
    this.container.removeAttribute('hidden')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'featured-episode', FeaturedEpisodeComponent))
